import { gql } from "@apollo/client"

export const DOCUMENTS_PARTICIPANT = gql`
  query DocumentParticipantRecords(
    $idTemplate: ID!
    $organization_id: ID!
    $participant_id: ID!
    $staff_id: ID!
    $participant_membership_id: ID!
  ) {
    documentRecords: getDocumentRecords(
      idTemplate: $idTemplate
      organization_id: $organization_id
      participant_id: $participant_id
      staff_id: $staff_id
    ) {
      data
      __typename
    }
    participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      staff_full_name
      __typename
    }
    serviceEpisode: getMaxServiceEpisode(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_membership_id: $participant_membership_id
      participant_id: $participant_id
    ) {
      service_episodes_id
    }
  }
`
export const DOCUMENTS_STAFF = gql`
  query DocumentStaffRecords(
    $idTemplate: ID!
    $staff_id: ID
    $organization_id: ID!
  ) {
    documentRecords: getDocumentRecords(
      idTemplate: $idTemplate
      organization_id: $organization_id
      staff_id: $staff_id
    ) {
      data
      __typename
    }
  }
`
